<template>
  <div class="">
    <div class="head-title">产品分类</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>设置添加产品模块时产品分类的选择。</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="">
      <div class="mMain">
        <div class="tianjia">
          <el-button icon="el-icon-plus" @click="onSubmit = true" type="primary"
            >添加</el-button
          >
          <el-table
            :data="tableData"
            border

            style="width: 100%; margin-top: 2.0rem"

            row-key="id"
            :tree-props="{ child: 'children', hasChildren: 'hasChildren' }"
          >
          <!---height="580"-->
            <el-table-column prop="label" label="名称"></el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
              <template slot-scope="scope">
                <el-button
                  @click="(onSubmits = true), dele(scope.row.id)"
                  type="text"
                  size="mini"
                  >添加子级</el-button
                >
                <el-button
                  @click="(dialogVisible = true), modify(scope.row)"
                  type="text"
                  size="mini"
                  >编辑</el-button
                >
                <el-button
                  @click="dekete(scope.row.id)"
                  size="mini"
                  type="text"
                  style="color:#f00000 !important"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!--<div class="paging">
            <pagination
              :total="total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              :auto-scroll="false"
              @pagination="userTable"
            />
          </div>--->

          <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
            <el-form ref="form" :model="form" label-width="8.0rem">
              <el-form-item label="添加" prop="name">
                <el-input clearable v-model="form.name"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onSubmit = false">取 消</el-button>
              <el-button type="primary" @click="numoo()">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="添加" center :visible.sync="onSubmits" width="30%">
            <el-form ref="form" :model="form" label-width="8.0rem">
              <el-form-item label="添加" prop="name">
                <el-input clearable v-model="form.name"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onSubmits = false">取 消</el-button>
              <el-button type="primary" @click="numoon()">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="修改" center  :visible.sync="dialogVisible" width="30%">
            <el-form ref="form" :model="form" label-width="8.0rem">
              <el-form-item label="修改" prop="name">
                <el-input clearable v-model="form.xname"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="modification()"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
export default {
  data() {
    return {
      tableData: [],
      hasChildren: true,
      tooken: "",
      onSubmit: false,
      onSubmits: false,
      dialogVisible: false,
      form: {
        name: "",
        id: "",
        xname: "",
        xid: "",
      },
      total:0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    //删除
    dekete(e) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/ProductCategory/delCategory",
              qs.stringify({
                id: e,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/Tagent");
              }
              this.userTable();
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });

              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    // 修改
    modification() {
      this.axios
        .post(
          "/crm/ProductCategory/editCategory",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.xname,
            id: this.form.xid,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.dialogVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.dialogVisible = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    // 编辑
    modify(row) {
      this.form.xname = row.label;
      this.form.xid = row.id;
    },
    // 添加子级
    numoon() {
      this.axios
        .post(
          "/crm/ProductCategory/addCategory",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            parent_id: this.form.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmits = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.form.name=""
          } else if (res.data.code == 0) {
            this.onSubmits = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    dele(e) {
      this.form.id = e;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    // 添加子级
    numoo() {
      this.axios
        .post(
          "/crm/ProductCategory/addCategory",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            parent_id: "0",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.form.name=""
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    userTable() {
      this.axios
        .post(
          "/crm/ProductCategory/getCategoryList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,

          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

